import { c as customElement } from "./-chunk-@lit.js";
import { h as html } from "./-chunk-lit-html.js";
import { L as LitElement } from "./-chunk-lit-element.js";
import { C as CartApi } from "./-cart-api.js";
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let QuantityInput = class extends LitElement {
  constructor() {
    super();
    this.input = null;
    this.cartApi = CartApi.getInstance();
  }
  firstUpdated() {
    this.input = this.querySelector("input.quantity__input");
    const minusButton = this.querySelector('button[name="minus"]');
    const plusButton = this.querySelector('button[name="plus"]');
    if (minusButton) {
      minusButton.addEventListener("click", (e) => this.onButtonClick(e));
    }
    if (plusButton) {
      plusButton.addEventListener("click", (e) => this.onButtonClick(e));
    }
    if (this.input) {
      this.input.addEventListener("change", (e) => this.onInputChange(e));
      this.input.addEventListener("keydown", (e) => this.onKeyDown(e));
    }
  }
  onButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.input) {
      console.error("No input element found");
      return;
    }
    const button = event.target;
    const currentValue = parseInt(this.input.value);
    const min = parseInt(this.input.min) || 0;
    const max = parseInt(this.input.max) || 99;
    let newValue = currentValue;
    if (button.name === "plus") {
      newValue = Math.min(max, currentValue + 1);
    } else {
      newValue = Math.max(min, currentValue - 1);
    }
    if (newValue !== currentValue) {
      this.input.value = newValue.toString();
      this.updateCart(newValue);
    }
  }
  onInputChange(event) {
    const input = event.target;
    const newValue = parseInt(input.value);
    this.updateCart(newValue);
  }
  onKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      const input = event.target;
      const newValue = parseInt(input.value);
      this.updateCart(newValue);
    }
  }
  async updateCart(quantity) {
    if (!this.input) {
      console.error("No input element found");
      return;
    }
    const variantId = this.input.getAttribute("data-variant-id");
    const key = this.input.getAttribute("data-item-key");
    if (!variantId || !key) {
      console.error("Missing required data:", { variantId, key });
      return;
    }
    const payload = {
      updates: {
        [key]: quantity
      }
    };
    document.dispatchEvent(new CustomEvent("cart:loading"));
    await this.cartApi.updateCart(payload);
    document.dispatchEvent(new CustomEvent("cart:loaded"));
  }
  createRenderRoot() {
    return this;
  }
  render() {
    return html`<slot></slot>`;
  }
};
QuantityInput = __decorateClass([
  customElement("lor-quantity-input")
], QuantityInput);
export {
  QuantityInput
};
